import React, { Ref, useEffect, useState } from "react";
import { classNames } from "@greeter/util";
import { alertCircle } from "ionicons/icons";

import { IonIcon } from "@ionic/react";
import css from "./StripeNoticeBar.module.scss";
import { FloatingActionBar, FloatingActionBarProps } from "@greeter/matter";

const Title: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>{children}</div>
  );
};

const SubTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div style={{ fontSize: "0.8rem" }}>{children}</div>;
};

type Props = Omit<FloatingActionBarProps, "type"> & {
  id?: string;
};

const StripeNoticeBar = React.forwardRef<HTMLDivElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <FloatingActionBar
        ref={ref}
        type="warning"
        {...props}
        {...classNames(className, css.StripeNoticeBar)}
      >
        <IonIcon {...classNames(css.Icon)} icon={alertCircle} />
        <div style={{ padding: "0.5rem 0" }}>
          <Title>Vi mangler betalingsoplysninger</Title>
          <SubTitle>Tryk for at færdiggøre din betalingskonto</SubTitle>
        </div>
      </FloatingActionBar>
    );
  }
);

export default StripeNoticeBar;
export type { Props as StripeNoticeBarProps };
